import type { TenantRef } from '@serievo/contracts';
import { useCallback, useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router';
import { applyChange, type ContextSelection, readSelection, resolveContext, writeSelection } from './contextParams';

/** Ngữ cảnh Công ty → Pháp nhân → Shop → Kỳ, nguồn sự thật là URL (chia sẻ link, nút Back hoạt động). */
export function useWorkContext(tenants: readonly TenantRef[] | undefined) {
  const [params, setParams] = useSearchParams();
  const raw = useMemo(() => readSelection(params), [params]);
  const resolved = useMemo(() => resolveContext(tenants ?? [], raw), [tenants, raw]);

  // URL thiếu hoặc trỏ tới mục không còn quyền: thay URL (không thêm lịch sử).
  useEffect(() => {
    if (tenants && resolved.changed) setParams(writeSelection(resolved.selection), { replace: true });
  }, [tenants, resolved, setParams]);

  const change = useCallback(
    (patch: ContextSelection) => setParams(writeSelection(applyChange(resolved.selection, patch))),
    [resolved.selection, setParams],
  );

  return { ...resolved, change };
}
